import React from 'react';

import Cards from 'bundles/apex/card/container';
import Header from './cards/header';
import Property from './cards/property';
import Listing from './cards/listing';

export function View() {
  return (
    <Cards>
      <Header />
      <Property />
      <Listing />
    </Cards>
  );
}

export default View;
